import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  insertEtiquetaUrl,
  updateEtiquetaUrl,
  getEtiquetasUrlByEtiquetaId,
  deleteEtiquetaUrl,
  updateEtiquetaUrlSort,
} from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_ETIQUETAS_URL_BY_ETIQUETA_ID(action) {
  try {
    const etiquetasUrlData = yield call(getEtiquetasUrlByEtiquetaId, action.payload)
    if (etiquetasUrlData.ok) {
      yield put({
        type: actions.ETIQUETAS_URL_LOAD_SUCCEEDED,
        payload: etiquetasUrlData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar etiquetas Url')
      put({
        type: actions.ETIQUETAS_URL_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ETIQUETAS_URL_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_ETIQUETA_URL(action) {
  try {
    const etiquetaUrlObj = yield call(insertEtiquetaUrl, action.payload)
    if (etiquetaUrlObj.ok) {
      putMessage(messageType.SUCCESS, 'Etiqueta Url creada correctamente')
      yield put({
        type: actions.ETIQUETAS_URL_INSERT_SUCCEEDED,
        payload: etiquetaUrlObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear etiqueta Url')
      yield put({
        type: actions.ETIQUETAS_URL_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear etiqueta Url')
    yield all([
      put({
        type: actions.ETIQUETAS_URL_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_ETIQUETA_URL(action) {
  try {
    const etiquetaUrlObj = yield call(updateEtiquetaUrl, action.payload)
    if (etiquetaUrlObj.ok) {
      putMessage(messageType.SUCCESS, 'Etiqueta Url modificada correctamente')
      yield put({
        type: actions.ETIQUETAS_URL_UPDATE_SUCCEEDED,
        payload: etiquetaUrlObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar etiqueta Url')
      yield put({
        type: actions.ETIQUETAS_URL_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar etiqueta Url')
    yield all([
      put({
        type: actions.ETIQUETAS_URL_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_ETIQUETA_URL(action) {
  try {
    const etiquetaUrlResult = yield call(deleteEtiquetaUrl, action.payload)
    if (etiquetaUrlResult.ok) {
      putMessage(messageType.SUCCESS, 'Etiqueta url eliminada correctamente')
      yield put({
        type: actions.ETIQUETA_URL_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Etiqueta url')
      yield put({
        type: actions.ETIQUETA_URL_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Etiqueta url')
    yield all([
      put({
        type: actions.ETIQUETA_URL_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_ETIQUETA_URL_SORT_ITEMS(action) {
  try {
    const etiquetaUrlObj = yield call(updateEtiquetaUrlSort, action.payload)
    if (etiquetaUrlObj.ok) {
      putMessage(messageType.SUCCESS, 'Orden de Etiquetas Url modificado correctamente')
      yield put({
        type: actions.ETIQUETAS_URL_SORT_UPDATE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar el Orden de etiqueta Url')
      yield put({
        type: actions.ETIQUETAS_URL_SORT_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar el Orden de etiqueta Url')
    yield all([
      put({
        type: actions.ETIQUETAS_URL_SORT_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.ETIQUETAS_URL_INSERT_REQUESTED, INSERT_ETIQUETA_URL),
    takeEvery(actions.ETIQUETAS_URL_UPDATE_REQUESTED, UPDATE_ETIQUETA_URL),
    takeEvery(actions.ETIQUETAS_URL_LOAD_REQUESTED, GET_ETIQUETAS_URL_BY_ETIQUETA_ID),
    takeEvery(actions.ETIQUETA_URL_DELETE_REQUESTED, DELETE_ETIQUETA_URL),
    takeEvery(actions.ETIQUETAS_URL_SORT_UPDATE_REQUESTED, UPDATE_ETIQUETA_URL_SORT_ITEMS),
  ])
}
